<template>
  <v-dialog
    persistent
    v-model="dialog"
    width="auto !important"
    class="wrapper-1 bg-white pos-relative"
    :class="[language === 'he' ? 'dir-rtl' : 'dir-ltr']"
  >
    <v-card>
      <v-card-title class="fs-1-5r mb-2" :class="isDarkMode ? 'bg-grey-dark-mode' : 'bg-grey'">
        {{ $t('Enter Verification Code') }}
      </v-card-title>
      <v-card-text class="pa-0 px-2">
        <div class="d-flex align-center">
          <span class="fs-1-12r">{{
            `${$t("We've sent a verification code to")}: ${email}. ${$t(
              'Please enter it here'
            )}:`
          }}</span>
          <v-text-field
            v-model="code"
            dense
            hide-details
            outlined
            type="text"
            :label="$t('Code')"
            class="ma-2 fs-1-25r"
            @keypress.enter="enterPressed"
          ></v-text-field>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <div class="d-flex justify-space-between pa-2">
        <Button
          :clickAction="() => verifyCode(code)"
          width="fit-content"
          btnType="blue"
          class="mx-2"
          :text="$t('Verify Code')"
          :disabled="code.length === 0"
        />
        <Button
          :clickAction="closeDialog"
          width="fit-content"
          btnType="grey"
          :text="$t('Cancel')"
          class="mx-2"
          :class="[isDarkMode && 'btn-grey-dark-mode']"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'EnterCodeDialog',
  data() {
    return {
      dialog: true,
      code: '',
    }
  },
  props: {
    email: String,
    closeDialog: Function,
    verifyCode: Function,
  },
  components: { Button },
  computed: {
    ...mapGetters(['language', 'isDarkMode']),
  },
}
</script>
